import { FC, useState } from "react";
import { Menu, MenuList, Tooltip, Button, MenuButton, useDisclosure, Box } from "@chakra-ui/react"
import { AddFilesMenuItem, CreateDraftAssetMenuItem } from "domains/interactions";
import { usePackContext } from "./context";
import { usePack } from "lib/hooks";
import { isReadOnly } from "lib/utils";
import { PlusIcon } from "lib/icons/plusIcon";
import { FieldTypes } from "lib/types";
import { DraftAssetModal } from "../draft-asset";

export const AddAssetMenu: FC = () => {
  const [ draftAsset, setDraftAsset ] = useState<{ type: string }>({ type: '' });
  const { packId } = usePackContext();
  const { data: pack } = usePack(packId);
  const { isOpen, onClose, onOpen } = useDisclosure();

  const packIsReadyOnly = isReadOnly(pack);

  const onCreate = (type) => {
    setDraftAsset({ ...draftAsset, type });
    onOpen();
  }

  return (
    <>
      <Menu autoSelect={false} matchWidth={true} strategy="absolute" placement="top">
        <Box>
          <Box width="100%">
            <MenuButton
              data-help="You can add links, files, text &amp; html to this pack by clicking this + at any time."
              mt="-6px"
              boxShadow="1px 0px 19px rgba(0, 0, 0, 0.16)"
              disabled={packIsReadyOnly}
              cursor={packIsReadyOnly ? 'not-allowed' : 'pointer'}
              borderRadius="50%"
              bg="brand.500"
              color="white"
              height="56px"
              width="56px"
              fontSize="2rem"
              transition="0.2s ease all"
              opacity={packIsReadyOnly ? 0.3 : 1}
              _hover={{
                bg: 'brand.900'
              }}
              _active={{
                bg: 'brand.900'
              }}
              _focus={{
                bg: 'brand.900'
              }}
            >
              <Box position="relative" top="-2px">
                {!packIsReadyOnly && <PlusIcon fill="white" />}
              </Box>
            </MenuButton>
          </Box>
        </Box>
        <MenuList width="180px" lineHeight={[2, 1]} mb="3px">
          <CreateDraftAssetMenuItem type={FieldTypes.HTML} create={() => onCreate(FieldTypes.HTML)} />
          <CreateDraftAssetMenuItem type={FieldTypes.TEXT} create={() => onCreate(FieldTypes.TEXT)} />
          <CreateDraftAssetMenuItem type={FieldTypes.LINK} create={() => onCreate(FieldTypes.LINK)} />
          <AddFilesMenuItem />
          <CreateDraftAssetMenuItem type={FieldTypes.PROMPT} create={() => onCreate(FieldTypes.PROMPT)} />
        </MenuList>
      </Menu>
      <DraftAssetModal isOpen={isOpen} asset={draftAsset as any} onClose={onClose} />
    </>
  )
}
